"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DataTableTranslation = {
    fi: {
        DataTable: {
            noDataText: 'Ei näytettäviä tietoja',
            loadingText: 'Lataa...',
        },
    },
    en: {
        DataTable: {
            noDataText: 'There is nothing to show',
            loadingText: 'Loading...',
        },
    },
};
exports.default = DataTableTranslation;
//# sourceMappingURL=DataTable.translation.js.map